import QCascaderPanel from './src/cascader-panel';



export default QCascaderPanel;
